import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'
import AdminGroupConcernScreen from './AdminGroupConcernScreen'

const AdminGroupConcernRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><AdminGroupConcernScreen /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminGroupConcernRoutes